export const blogCategories = [
  'All',
  'Routine',
  'Ingredients',
  'Skin Concerns',
  'Skin Science',
];

export const blogPosts = [
  {
    id: 'layer-serums',
    slug: 'how-to-layer-serums-correctly',
    title: 'How to Layer Serums Correctly',
    snippet:
      'A simple AM/PM order for actives so your skin gets maximum benefit without irritation.',
    excerpt:
      'Layering serums is not about using more products — it is about applying them in an order that lets each active work without cancelling the next.',
    category: 'Routine',
    date: 'Apr 02, 2026',
    readTime: '5 min read',
    featured: true,
    image:
      'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=900&q=80',
    body: [
      'Start with the thinnest, most water-based formulas and move toward richer textures. In the morning, cleanse, apply antioxidant serums like Vitamin C, then moisturizer and SPF — always last.',
      'At night, cleanse, use treatment serums (niacinamide, retinoids, or acids on alternate nights), then seal with a hydrating moisturizer or ceramide cream.',
      'Do not stack strong actives on the same night. Pair niacinamide with hydrators freely, but keep acids and retinoids on separate evenings until your barrier feels comfortable.',
    ],
  },
  {
    id: 'niacinamide-vitamin-c',
    slug: 'niacinamide-vs-vitamin-c',
    title: 'Niacinamide vs Vitamin C',
    snippet:
      'Understand what each active does, when to use them, and how to combine them safely.',
    excerpt:
      'Both are brightening heroes, but they solve different problems. Knowing when to reach for each one keeps your routine efficient and irritation-free.',
    category: 'Ingredients',
    date: 'Mar 25, 2026',
    readTime: '6 min read',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=900&q=80',
    body: [
      'Vitamin C is your daytime antioxidant — it helps defend against environmental stress and supports a more even, luminous tone when used with daily SPF.',
      'Niacinamide is versatile: it supports barrier function, helps regulate oil, and improves the look of pores and uneven tone. It works well morning or night.',
      'Modern formulas allow many people to use both in the same routine. If you are new to actives, introduce one for two weeks, then add the second and watch for redness or stinging.',
    ],
  },
  {
    id: 'dark-spots',
    slug: 'fixing-dark-spots-the-right-way',
    title: 'Fixing Dark Spots the Right Way',
    snippet:
      'A practical 8-week plan for pigmentation with sunscreen, brightening actives, and consistency.',
    excerpt:
      'Dark spots fade slowly because melanin production is stubborn. The fastest path is daily protection plus targeted brighteners used consistently.',
    category: 'Skin Concerns',
    date: 'Mar 18, 2026',
    readTime: '7 min read',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=900&q=80',
    body: [
      'Weeks 1–2: Establish SPF every morning — no exceptions. UV exposure keeps pigmentation active even when you are treating it at night.',
      'Weeks 3–6: Add a brightening serum (Vitamin C in AM, niacinamide in PM works well for many Indian skin tones). Avoid picking at spots or harsh scrubs.',
      'Weeks 7–8: Evaluate progress. If marks persist, continue the same routine — pigmentation often needs 8–12 weeks. Consistency beats switching products weekly.',
    ],
  },
  {
    id: 'barrier-health',
    slug: 'why-barrier-health-comes-first',
    title: 'Why Barrier Health Comes First',
    snippet:
      'If your skin stings or stays red, your barrier might be compromised. Here is how to repair it.',
    excerpt:
      'A damaged barrier makes every active feel harsh. Repair first, then reintroduce treatments — your skin will respond better and faster.',
    category: 'Skin Science',
    date: 'Mar 10, 2026',
    readTime: '5 min read',
    featured: false,
    image:
      'https://images.unsplash.com/photo-1570194065650-d99fb4abbd90?w=900&q=80',
    body: [
      'Signs of barrier stress include burning after gentle products, persistent redness, flaking, and sudden sensitivity to formulas you once tolerated.',
      'Pause exfoliating acids and retinoids for 10–14 days. Use a gentle cleanser, a ceramide-rich moisturizer, and SPF. Keep the routine minimal.',
      'Once stinging stops, reintroduce one active at a time, every five to seven days. Barrier-first skincare is not boring — it is what makes actives work long term.',
    ],
  },
];
